<template>
    <tribal-summary-column-renderer v-if="isPinned" :params />
    <tribal-account-cell-renderer v-else :params />
</template>

<script setup lang="ts">
import {LedgerAccount} from '@/types/reports/LedgerAccount'
import TribalSummaryColumnRenderer from '@/tribal/TribalSummaryColumnRenderer.vue'
import TribalAccountCellRenderer from '@/tribal/TribalAccountCellRenderer.vue'
import {computed, Ref} from 'vue'

const props = defineProps({
    params: {
        type: Object as () => {
            data: LedgerAccount & {
                rowIsPinned?: Boolean
            },
            context: {
                panelId: Number,
                panelPathSegment: String,
                searchParams: Ref<{
                    fromDate: string,
                    toDate: string
                }>
            }
        },
        required: true
    }
})

const isPinned = computed(() => {
    return props.params.data.rowIsPinned
})

</script>

<style scoped>

</style>